import { Chip, Typography } from '@mui/material'
import { DateTime } from 'luxon'
import { useTranslate } from 'ra-core'
import { FunctionField, SimpleShowLayout, useRecordContext } from 'react-admin'

import { ShowSubSectionTitleCard, useShowStyles } from '../common/show'

export const formatCalendarDate = (isoDate) => DateTime.fromISO(isoDate).toLocaleString(DateTime.DATE_SHORT)

export const UserSuspensionSection = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  const showClasses = useShowStyles()
  const suspension = record?.user_account?.suspension
  if (!suspension) {
    return null
  }
  return (
    <>
      <ShowSubSectionTitleCard text="suspension" />
      <SimpleShowLayout sx={showClasses.fieldContainer} data-testid="user-suspension">
        <Typography>
          {suspension.suspended_until
            ? translate('resources.users.show.suspension.until', {
                date: formatCalendarDate(suspension.suspended_until),
              })
            : translate('resources.users.show.suspension.indefinitely')}
        </Typography>
        <Typography variant="body2">
          {translate('resources.users.show.suspension.reason', { reason: suspension.reason })}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {translate('resources.users.show.suspension.author', {
            author: suspension.suspended_by.full_name,
            date: formatCalendarDate(suspension.created_on),
          })}
        </Typography>
      </SimpleShowLayout>
    </>
  )
}

export const UserSuspendedChip = () => {
  const translate = useTranslate()
  return (
    <Chip
      component="span"
      label={translate('resources.users.enums.suspension.suspended')}
      size="small"
      color="warning"
      sx={{ borderRadius: 999, fontWeight: 600 }}
    />
  )
}

export const UserSuspendedChipField = (props) => (
  <FunctionField
    sortable={false}
    {...props}
    render={(record) => (record?.user_account_is_suspended ? <UserSuspendedChip /> : null)}
  />
)
